/* RESPONSIBLE TEAM: team-fin-qa */
// Bridge route for QA conversations React view
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAiAgentAnalyzeMonitorConversationsRoute extends Route {
  queryParams = {
    page: { refreshModel: false },
    perPage: { refreshModel: false },
    reviewStatus: { refreshModel: false },
    reviewerId: { refreshModel: false },
    revieweeId: { refreshModel: false },
    sampleWeek: { refreshModel: false },
  };

  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.analyze.monitor.conversations',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAiAgentAnalyzeMonitorConversationsRoute, {
  overrideRenderTemplate: false,
});
